/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGATourGetOrCreateModelForSlateInput = {|
  slateId?: ?string,
  clientMutationId?: ?string,
|};
export type PGAModelBuilderPageGetOrCreateModelMutationVariables = {|
  input: PGATourGetOrCreateModelForSlateInput
|};
export type PGAModelBuilderPageGetOrCreateModelMutationResponse = {|
  +pgaTourGetOrCreateModelForSlate: ?{|
    +model: ?{|
      +id: string,
      +fairwayGrassTypes: {|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +categoryName: string,
          |}
        |}>
      |},
      +roughGrassTypes: {|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +categoryName: string,
          |}
        |}>
      |},
      +greenGrassTypes: {|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +categoryName: string,
          |}
        |}>
      |},
      +numRounds: number,
      +minRounds: number,
      +fromDate: any,
      +toDate: any,
      +minYards: number,
      +maxYards: number,
      +courses: {|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +name: string,
          |}
        |}>
      |},
      +coursePars: $ReadOnlyArray<number>,
    |}
  |}
|};
export type PGAModelBuilderPageGetOrCreateModelMutation = {|
  variables: PGAModelBuilderPageGetOrCreateModelMutationVariables,
  response: PGAModelBuilderPageGetOrCreateModelMutationResponse,
|};
*/


/*
mutation PGAModelBuilderPageGetOrCreateModelMutation(
  $input: PGATourGetOrCreateModelForSlateInput!
) {
  pgaTourGetOrCreateModelForSlate(input: $input) {
    model {
      id
      fairwayGrassTypes {
        edges {
          node {
            id
            categoryName
          }
        }
      }
      roughGrassTypes {
        edges {
          node {
            id
            categoryName
          }
        }
      }
      greenGrassTypes {
        edges {
          node {
            id
            categoryName
          }
        }
      }
      numRounds
      minRounds
      fromDate
      toDate
      minYards
      maxYards
      courses(first: 150) {
        edges {
          node {
            id
            name
          }
        }
      }
      coursePars
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PGATourGrassCategoryTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PGATourGrassCategoryType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "categoryName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PGATourGetOrCreateModelForSlatePayload",
    "kind": "LinkedField",
    "name": "pgaTourGetOrCreateModelForSlate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PGATourModelType",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourGrassCategoryTypeConnection",
            "kind": "LinkedField",
            "name": "fairwayGrassTypes",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourGrassCategoryTypeConnection",
            "kind": "LinkedField",
            "name": "roughGrassTypes",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourGrassCategoryTypeConnection",
            "kind": "LinkedField",
            "name": "greenGrassTypes",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numRounds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minRounds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fromDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "toDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minYards",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxYards",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 150
              }
            ],
            "concreteType": "PGATourCourseTypeConnection",
            "kind": "LinkedField",
            "name": "courses",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PGATourCourseTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PGATourCourseType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "courses(first:150)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "coursePars",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderPageGetOrCreateModelMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAModelBuilderPageGetOrCreateModelMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "81655ac925f5e42597be7c5a01ef20c4",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderPageGetOrCreateModelMutation",
    "operationKind": "mutation",
    "text": "mutation PGAModelBuilderPageGetOrCreateModelMutation(\n  $input: PGATourGetOrCreateModelForSlateInput!\n) {\n  pgaTourGetOrCreateModelForSlate(input: $input) {\n    model {\n      id\n      fairwayGrassTypes {\n        edges {\n          node {\n            id\n            categoryName\n          }\n        }\n      }\n      roughGrassTypes {\n        edges {\n          node {\n            id\n            categoryName\n          }\n        }\n      }\n      greenGrassTypes {\n        edges {\n          node {\n            id\n            categoryName\n          }\n        }\n      }\n      numRounds\n      minRounds\n      fromDate\n      toDate\n      minYards\n      maxYards\n      courses(first: 150) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n      coursePars\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b14acff74f5a2ffd74253926f0d58d9c';

module.exports = node;
